export enum ECookieProcessingServices {
  APPLE_SIGN_IN = 'Apple Sign-in',
  AYET = 'ayeT',
  CPX = 'CPX Research',
  COMETCHAT = 'CometChat',
  DISCORD = 'Discord',
  FACEBOOK = 'Facebook SDK',
  FACEBOOK_SOCIAL = 'Facebook Social Plugins',
  GOOGLE_ANALYTICS = 'Google Analytics',
  GOOGLE_ANALYTICS_FIREBASE = 'Google Analytics for Firebase',
  GOOGLE_FIREBASE = 'Google Firebase',
  GOOGLE_SIGN_IN = 'Google Sign-In',
  GOOGLE_SYNDICATION = 'Google Syndication',
  GTM = 'Google Tag Manager',
  GSTATIC = 'gstatic.com',
  HELPSCOUT = 'Helpscout',
  HUAWEI = 'Huawei Sign-In',
  JSDELIVR = 'JSDelivr',
  KLARNA = 'Klarna',
  ONE_SIGNAL = 'OneSignal',
  PAYMENT_WALL = 'paymentwall',
  PAYPAL = 'PayPal',
  PAYSAFE = 'PaySafe',
  PAYONE = 'Payone',
  REVENUE_UNIVERSE = 'Revenue Universe',
  SEND_GRID = 'SendGrid',
  SENDINBLUE = 'Sendinblue',
  SENTRY = 'Sentry',
  SHIELD_SQUARE = 'ShieldSquare',
  SOVENDUS = 'Sovendus',
  STEAM = 'Steam',
  TWITCH = 'Twitch',
  TWITTER = 'Twitter',
  UC_CPM = 'Usercentrics Consent Management Platform',
  YOUTUBE = 'YouTube Video',
  RECAPTCHA = 'reCAPTCHA',
}

export type TCookieProcessingServices = Record<
  ECookieProcessingServices,
  boolean
>;

export type TUCConsentEventDetails = TCookieProcessingServices & {
  event: 'consent_status';
  type: 'explicit' | 'implicit';
  action:
    | 'onInitialPageLoad'
    | 'onAcceptAllServices'
    | 'onDenyAllServices'
    | 'onUpdateServices'
    | 'onSessionRestored';
};
